export default __webpack_public_path__ + "static/media/mustardsauce.2cb0d1fd.jpg";